class DraggableArea{
    constructor(element){
        this.main = element;
        this._content = element.querySelector('.draggable-area__content')
           
        this._dragging = false;

        this._x = 0;
        this._touchXo = 0;

        this._isActive = window.innerWidth > 991;

        this._clickEnabled = true;
        this._onClickLinkHandler = this._onClickLink.bind(this);

        this.reset();
        
        setTimeout(()=>{
            this._onResize();
        }, 0);
        

        this._content.addEventListener('mousedown', this._onMouseDown.bind(this));
        document.addEventListener('mousemove', this._onMouseMove.bind(this));
        document.addEventListener('mouseup', this._onMouseUp.bind(this));
        window.addEventListener('resize', this._onResize.bind(this));
    }

    _onMouseDown(e){
        if(this._isActive && !this._dragging){
            this._dragging = true;
            
            this._touchXo = e.clientX;
        }
    }

    move(x){
        this._content.style.transform = 'translate(' + x +'px)';
        this._x = x;
    }

    _onMouseMove(e){
        if(this._isActive && this._dragging){

            let x = this._x + e.clientX - this._touchXo;
            
            if(x > 0){
                x = 0;
            }else if(x < - (this._content.scrollWidth - this.main.offsetWidth)){
                x = -(this._content.scrollWidth - this.main.offsetWidth);
            }

            this._content.style.transform = 'translate(' + x +'px)';
            
            this._clickEnabled = false;
        }
    }

    _onMouseUp(e){
        if(this._isActive && this._dragging){
            this._x = this._x + e.clientX - this._touchXo;
            this._dragging = false;
            this._touchXo = 0;

            setTimeout(()=>{
                this._clickEnabled = true;
            }, 0)            
        } 
    }

    reset(){
        this._content.style.transform = 'translate(0px)';
        this._x = 0;
        this._touchXo = 0;
        
        Array.from(this._content.querySelectorAll('a')).forEach((btn)=>{
            //Remuevo por las dudas que se haya ejecutado con los mismos items
            btn.removeEventListener('click', this._onClickLinkHandler);

            btn.addEventListener('click', this._onClickLink.bind(this));
        });
    }
                                                                                                                                                                                                                                                                                                                                    
    _onResize(e){
        if(this._content.scrollWidth - 1 <= this.main.offsetWidth){
            this.main.classList.add('draggable-area--disabled')
        }else{
            this.main.classList.remove('draggable-area--disabled')
        }
        
        this._content.style.transform = 'translate(0px)';
        this._x = 0;
        this._touchXo = 0;

        if(window.innerWidth > 991){
            this._isActive = true;
        }else{
            this._isActive = false;
            this._clickEnabled = true;
        }
    }

    _onClickLink(e){
        if(!this._clickEnabled){
            e.preventDefault();
            e.stopPropagation();        
        }
    }
}

export default DraggableArea;